
(function($){
	$(function(){


        $('.phone-nav').click(function () {
            $("body").toggleClass("navShown");
            $(".nav-wrap").fadeToggle()
        });




        $('.mega-menu').click(function () {
            $("body").toggleClass("btnShown");
        });

        // $(".sub_menu").parent("li").addClass("has-sub-nav");
        // $(".has-sub-nav").each(function () {
        //     var $$this = $(this);
            
        //     if ($(window).width() > 1024) {
        //         $$this.find('> a').mouseenter(function () {
        //             $$this.find('.sub_menu').fadeIn();
        //         })
        //         $$this.mouseleave(function () {
        //             $('.sub_menu').fadeOut();
        //         })
        //     }
        //     if ($(window).width() < 1025) {
        //         $$this.find('> a').click(function (e) {
        //             e.preventDefault();
        //             $$this.find('.sub_menu').slideToggle();
        //         })
               
        //     }
            
            
        // })









        //FAQs Accordion Function
        $(".accordion-item").each(function(){
            var $this = $(this);
            $this.find(" > h5").on("click touch", function(){
                $(".accordion-item").removeClass("active")
                $(".accordion-item .accordion-content").slideUp();
                if($this.find(".accordion-content:visible").length){
                    $(".accordion-item").removeClass("active")
                    $(".accordion-item .accordion-content").slideUp();
                }
                else{
                    $this.addClass("active")
                    $(".accordion-item .accordion-content").slideUp();
                    $this.find(" > .accordion-content").slideDown();
                }
            })
        })
        

        // Tab 
        $('.tab-wrap .tab-items').hide();
        $('.tab-wrap .tab-items:first').show();
        $('.tabs-nav li:first').addClass('tab-active');
        
        // Change tab class and display content
        $('.tabs-nav a').on('click', function(event){
          event.preventDefault();
          $('.tabs-nav li').removeClass('tab-active');
          $(this).parent().addClass('tab-active');
          $('.tab-wrap .tab-items').hide();
          $($(this).attr('href')).show();
        });


       
   
              
        if ($(window).width() < 767) {
            $('.best-sellers-slider').slick({
                arrows: false,
                // autoplay: true,
                // autoplaySpeed: 2000,
                infinite: true,
                navigation: false,
                speed: 300,
                dots: true,
                arrows:false,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }
        


        if ($(window).width() < 767) {
            $('.reviews-slider').slick({
                arrows: false,
                autoplay: true,
                autoplaySpeed: 2000,
                infinite: true,
                dots: true,
                arrows:false,
                navigation: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }
        


        
  
        $('.cart-trigger').click(function (e) {
            e.preventDefault()
            $("body").toggleClass("cartShown");
            $("html").toggleClass("scrollOff");
            $('.cart-backdrop').fadeIn();
        });

        $('.cart-backdrop').click(function () {
            $("body").removeClass("cartShown");
            $("html").removeClass("scrollOff");
            $('.cart-backdrop').fadeOut();
        });
        $(document).on('click', '.cart-close, .close-cart', function(){
            $("body").removeClass("cartShown");
            $("html").removeClass("scrollOff");
            $('.cart-backdrop').fadeOut();
        })

  



    }); //end ready funtion


    $('.tab__item').click(function(){
        var myTab = $(this).attr('data-target');
        $('.tab__item').removeClass('active');
        $(this).addClass('active');
        $('.compare-row').removeClass('active');
        $(myTab).addClass('active');
    })

    

	

})(jQuery)











$(".product__side-img").slick({
    //slidesToShow: 5,
    //slidesToScroll: 1,
    //arrows: true,
    //fade: false,
    //focusOnSelect: false,
    //vertical: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: $('.slick-prev'),
  nextArrow: $('.slick-next'),
  fade: false,
  focusOnSelect: true,
  vertical: true,
  swipe: true,
  swipeToSlide: true,
  touchMove: true,
  infinite: true,
    asNavFor: ".product__main-img",
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
            },
        },
    ],
});
$(".product__main-img").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".product__side-img",
    dots: false,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            },
        },
    ],
});


var prod_url = $(".product-tab__tab.active").attr('data-url');
// product tab
$(".product-tab__tab").on("click", function () {
    var tabId = $(this).attr("data-target");
    prod_url = $(this).attr('data-url');
    $(".product-tab__tab").removeClass("active");
    $(".product-tab__item-wrap").removeClass("active");
    $(this).addClass("active");
    console.log(tabId);
    $(tabId).addClass("active");

    fetch(prod_url+"?section_id=main-product")
      .then((response) => response.text())
      .then((data) => {
        var nutri_html = $(data);
        var nutri_info = $(".nutrition-table", nutri_html);
        $(".nutrition-table").replaceWith(nutri_info);

        var ingredient = $(".ingredients__content", nutri_html);
        $(".ingredients__content").replaceWith(ingredient);
      });
})

// $(".product-tab__select").on("change", function () {
//     $(".product-tab__item-wrap").removeClass("active");
//     $("#" + this.value).addClass("active");
    // if (this.value == "product") {
    //     $("#" + this.value).addClass("active");
    // } else if (this.value === "shipping") {
    //     $("#" + this.value).addClass("active");
    // }
// });








// nutrition modal
// $(".product-tab__btn_nutrition").click(function () {
//     $(".nutrition").fadeIn();
//     $(".modal-wrapper").addClass("modal-wrap");
// });
$(".close").click(function () {
    $(".nutrition").fadeOut();
    $(".modal-wrapper").removeClass("modal-wrap");
});
$(".modal-wrapper").click(function () {
    $(".modal-wrapper").toggleClass("modal-wrap");
    $(".nutrition").fadeOut();
    $(".ingredients").fadeOut();
});


// ingredients modal
// $(".product-tab__btn_ingredients").click(function () {
//     $(".ingredients").fadeIn();
//     $(".modal-wrapper").addClass("modal-wrap");
// });
$(".close").click(function () {
    $(".ingredients").fadeOut();
    $(".modal-wrapper").removeClass("modal-wrap");
});



// customer slider
$(".customer-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    focusOnSelect: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                centerMode: false,
            },
        },
    ],
});

$('.arrow__left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.arrow__right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});








var min_order = 1;
var item_price = 5.5;
var items = [];

// if(freeProductPage){
//     var items = [{"id" : freeProductVariant, "quantity" : 1}];
// }else{
//     var items = [];
// }

    $(".product__variant-select").on("change", function () {
        $(this).parent().parent().parent().parent().find('.variant__item-checkbox').prop('checked', true);
        $(this).parent().parent().parent().parent().find('.variant__item-checkbox').trigger('change');
    });


// $(".variant__item-checkbox").change(function() {
//         items = [];
//         var total_selected = 0;
//         var freeProduct = 0;
//         $('.variant__item-checkbox:checked').each(function(){
//             var prod_variant = $(this).parent().find('.product__variant-select').attr('data_variant');
//             var selected_num = parseInt($(this).parent().find('.product__variant-select').val());
//             total_selected = total_selected + selected_num;
//             items.push({
//                 "id" : prod_variant,
//                 "quantity" : selected_num
//                 });

//                 if(prod_variant == freeProductVariant){
//                     freeProduct = 1;
//                 }
//         });
    
//         console.log(total_selected);
//         console.log(items);
//         if(total_selected >= min_order){
//             $('.paroduct__btn').removeClass('btn_disabled');
//         }else{
//             $('.paroduct__btn').addClass('btn_disabled');
//         };
//         if(freeProductPage){
//             var total_price = (total_selected - 1) * item_price;
//         }else{
//             var total_price = total_selected  * item_price;
//         }
//         var total_price = ((total_selected - freeProduct)  * item_price).toFixed(2);
//         $('.btn_price').text(currencySymbol + total_price);
// });





$('.paroduct__btn').click(function(e){
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json',
        //   data: JSON.stringify(itemData),
        //   data: {items},
        data: $(this).parent().find('.single-product-form').serialize(),
          success: function(data) {
            get_cart_details();
            console.log('done');
            update_free();
          },
          error: 'addToCartFail'
      });
  });

  $('.card-button').click(function(e){
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json',
          data: $(this).parent().find('.card-form').serialize(),
          success: function(data) {
            get_cart_details();
            console.log('done');
          },
          error: 'addToCartFail'
      });
  });



  
  //   Add
  function get_cart_details(){
    fetch("?section_id=cart-drawer")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        var cart_items = $(".cart-inner", cart_html);
        $(".cart-inner").replaceWith(cart_items);
      });
  
      fetch("?section_id=header")
      .then((response) => response.text())
      .then((headerData) => {
        var cart_html = $(headerData);
        var cart_count = $(".cart-trigger dfn", cart_html);
        $(".cart-trigger dfn").replaceWith(cart_count);
      });
      $('body').addClass('cartShown');
      $('.cart-backdrop').fadeIn();

      
  };
  
  
  // Increase and decrease
  function increaseItem(e, el) {
    var $input = el.previousElementSibling;
    var value = parseInt($input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    $input.value = value;            
    change_qty($input);
  }
  
  function decreaseItem(e, el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        $input.value = value;            
        change_qty($input);
    }
  }
  
  //   change quantity
  function change_qty($input){
    var variant_id= $($input).attr("data-id");
    var quantity= $($input).val();          
    var data = { updates: {} };
    data.updates[variant_id] = quantity;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {               
        get_cart_details();
      }
    });
  };
  
  
  
  //   Remove
  function itemRemove(e , el){
    e.preventDefault();
    var variant_id = $(el).attr('data-id');
    console.log(variant_id);
    var data = { updates: {} };
    data.updates[variant_id] = '0';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        get_cart_details();
      }
    });
        //  $(el).parent().parent().remove();
  }


  function update_free(){

    $.getJSON('/cart.js', function(cart) {
        var cart_items = cart.items;
        for(cart_item in cart_items){
            var productID = cart_items[cart_item].product_id;
            console.log(cart_items[cart_item].product_id);
            // if(productID == free_product){
            //     console.log('item matched');
            //     var variant_id= cart_items[cart_item].id;
            //     var quantity= 1;          
            //     var data = { updates: {} };
            //     data.updates[variant_id] = quantity;
            //     jQuery.ajax({
            //     type: 'POST',
            //     url: '/cart/update.js',
            //     data: data,
            //     dataType: 'json',
            //     success: function(res) {               
            //         get_cart_details();
            //     }
            //     });
            // }
        }

    })



  }



  $('.imagine__icn').click(function(e){
    e.preventDefault();
    $(this).parent().parent().addClass('show-hover');
  });
  $('.imagine__close').click(function(){
    $(this).parent().parent().removeClass('show-hover');
  });

  // $('.cart__note-trigger').click(function(){
  //   $(this).next().slideToggle();
  // })


document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".swiper-key", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    freeMode: true,
    //autoplay: {
      //delay: 3000,
      //disableOnInteraction: false
    //},
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".review-grid-js", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
});